export const permissions = {
  mraEditModels: { subject: 'mraModels', actions: 'edit' },
  LitigationReopenCase: { subject: 'LitigationReopenCase', actions: 'edit' },
  LitigationEdit: { subject: 'Litigation', actions: 'edit' },
  ArbitrationEdit: { subject: 'Arbitration', actions: 'edit' },
  LitigationView: { subject: 'Litigation', actions: 'view' },
  ArbitrationView: { subject: 'Arbitration', actions: 'view' },
  'Dashboard Admin': { subject: 'Dashboard Admin', actions: 'edit' },
  AppraisalSetValueReady: {
    subject: 'AppraisalSetValueReady',
    actions: 'edit',
  },
  EquiFinderEditProperty: { subject: 'EquiFinderProperty', actions: 'edit' },
  EquiFinderMaintainAppSettings: {
    subject: 'EquiFinderMaintainAppSettings',
    actions: 'edit',
  },
  EquiFinderMaintainDataImports: {
    subject: 'EquiFinderMaintainData',
    actions: 'import',
  },
  EquiFinderEditProdigyScore: {
    subject: 'EquiFinderProdigyScore',
    actions: 'edit',
  },
  AppealMassGenerateEvidencePacket: {
    subject: 'AppealMassGenerateEvidencePacket',
    actions: 'edit',
  },
  AppealMassAutoRecommendations: {
    subject: 'AppealMassAutoRecommendations',
    actions: 'edit',
  },
  AppraisalViewSensitiveData: {
    subject: 'SensitiveData',
    actions: 'view',
  },
  AppraisalAdministration: {
    subject: 'AppraisalAdministration',
    actions: 'edit',
  },
  AppraisalPropertyIdentificationView: {
    subject: 'PropertyIdentification',
    actions: 'view',
  },
  AppraisalPropertyIdentificationEdit: {
    subject: 'PropertyIdentification',
    actions: 'edit',
  },
  AppraisalLegalDescriptionView: {
    subject: 'AppraisalLegalDescription',
    actions: 'view',
  },
  AppraisalLegalDescriptionEdit: {
    subject: 'AppraisalLegalDescription',
    actions: 'edit',
  },
  AppraisalPropertyCharacteristicsView: {
    subject: 'AppraisalPropertyCharacteristics',
    actions: 'view',
  },
  AppraisalPropertyCharacteristicsEdit: {
    subject: 'AppraisalPropertyCharacteristics',
    actions: 'edit',
  },
  AppraisalSitusAddressView: {
    subject: 'AppraisalSitusAddress',
    actions: 'view',
  },
  AppraisalSitusAddressEdit: {
    subject: 'AppraisalSitusAddress',
    actions: 'edit',
  },
  AppraisalOwnerView: { subject: 'AppraisalOwner', actions: 'view' },
  AppraisalOwnerEdit: { subject: 'AppraisalOwner', actions: 'edit' },
  'AppraisalPropertyComments View': {
    subject: 'AppraisalPropertyComments',
    actions: 'view',
  },
  'AppraisalPropertyComments Edit': {
    subject: 'AppraisalPropertyComments',
    actions: 'edit',
  },
  AppraisalDeedsView: {
    subject: 'AppraisalDeeds',
    actions: 'view',
  },
  AppraisalDeedsEdit: {
    subject: 'AppraisalDeeds',
    actions: 'edit',
  },
  AppraisalSalesView: {
    subject: 'AppraisalSales',
    actions: 'view',
  },
  AppraisalSalesEdit: {
    subject: 'AppraisalSales',
    actions: 'edit',
  },
  AppraisalTaxingUnitsView: {
    subject: 'AppraisalTaxingUnits',
    actions: 'view',
  },
  AppraisalTaxingUnitsEdit: {
    subject: 'AppraisalTaxingUnits',
    actions: 'edit',
  },
  AppraisalExemptionsView: {
    subject: 'AppraisalExemptions',
    actions: 'view',
  },
  AppraisalExemptionsEdit: {
    subject: 'AppraisalExemptions',
    actions: 'edit',
  },
  AppraisalPropertyEventsEdit: {
    subject: 'AppraisalPropertyEvents',
    actions: 'edit',
  },
  AppraisalAgentView: {
    subject: 'AppraisalAgent',
    actions: 'view',
  },
  AppraisalAgentEdit: {
    subject: 'AppraisalAgent',
    actions: 'edit',
  },
  AppraisalValuationView: {
    subject: 'AppraisalValuation',
    actions: 'view',
  },
  AppraisalValuationEdit: {
    subject: 'AppraisalValuation',
    actions: 'edit',
  },
  AppraisalLandView: { subject: 'AppraisalLand', actions: 'view' },
  AppraisalLandEdit: { subject: 'AppraisalLand', actions: 'edit' },
  AppraisalImprovementView: {
    subject: 'AppraisalImprovement',
    actions: 'view',
  },

  AppraisalImprovementEdit: {
    subject: 'AppraisalImprovement',
    actions: 'edit',
  },

  AppraisalSmartGroupsView: {
    subject: 'AppraisalSmartGroups',
    actions: 'view',
  },

  AppraisalSmartGroupsEdit: {
    subject: 'AppraisalSmartGroups',
    actions: 'edit',
  },

  AppraisalSmartListView: {
    subject: 'AppraisalSmartList',
    actions: 'view',
  },

  AppraisalSmartListEdit: {
    subject: 'AppraisalSmartList',
    actions: 'edit',
  },

  AppraisalLinkSketch: {
    subject: 'AppraisalLinkSketch',
    actions: 'edit',
  },

  // AppraisalBuilderPlanView: {
  //   subject: 'AppraisalBuilderPlan',
  //   actions: 'view',
  // },

  // AppraisalBuilderPlanEdit: {
  //   subject: 'AppraisalBuilderPlan',
  //   actions: 'edit',
  // },

  AppraisalBPPPersonalDetailView: {
    subject: 'AppraisalBPPPersonalDetail',
    actions: 'view',
  },

  AppraisalBPPPersonalDetailEdit: {
    subject: 'AppraisalBPPPersonalDetail',
    actions: 'edit',
  },

  AppraisalExecuteCreatePropertyWalkthru: {
    subject: 'AppraisalCreatePropertyWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteMassCreatePropertyWalkthru: {
    subject: 'AppraisalMassCreatePropertyWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteCreateOwnerWalkthru: {
    subject: 'AppraisalCreateOwnerWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteCreateAgentWalkthru: {
    subject: 'AppraisalCreateAgentWalkthru',
    actions: 'execute',
  },

  AppraisalAgentMassEntryWalkthru: {
    subject: 'AppraisalAgentMassEntryWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteCreateMortgageLenderWalkthru: {
    subject: 'AppraisalCreateMortgageLenderWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteMergePropertiesWalkthru: {
    subject: 'AppraisalMergePropertiesWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteSplitPropertyWalkthru: {
    subject: 'AppraisalSplitPropertyWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteOwnershipTransferWalkthru: {
    subject: 'AppraisalOwnershipTransferWalkthru',
    actions: 'execute',
  },

  AppraisalExecuteRenditionWalkthru: {
    subject: 'AppraisalRenditionWalkthru',
    actions: 'execute',
  },

  AppraisalImportValuations: {
    subject: 'AppraisalImportValuations',
    actions: 'execute',
  },

  AppraisalPropertyEventsView: {
    subject: 'AppraisalPropertyEvents',
    actions: 'view',
  },
  TaxingUnitPortalEdit: { subject: 'TaxingUnitPortal', actions: 'edit' },
  TaxingUnitPortalCreate: { subject: 'TaxingUnitPortal', actions: 'create' },
  TaxingUnitPortalImport: { subject: 'TaxingUnitPortal', actions: 'import' },
  EventsEditEvent: { subject: 'Events', actions: 'edit' },
  EventsEventAdministration: {
    subject: 'EventsEventAdministration',
    actions: 'edit',
  },
  EventsDelete: { subject: 'Events', actions: 'delete' },

  EconUnitView: {
    subject: 'EconUnit',
    actions: 'view',
  },

  EconUnitEdit: {
    subject: 'EconUnit',
    actions: 'edit',
  },

  AppealEdit: {
    subject: 'Appeal',
    actions: 'edit',
  },

  AppraisalLendersView: { subject: 'AppraisalLenders', actions: 'view' },
  AppraisalLendersEdit: { subject: 'AppraisalLenders', actions: 'edit' },
  AppraisalBuilderPlansView: {
    subject: 'AppraisalBuilderPlans',
    actions: 'view',
  },
  AppraisalBuilderPlansEdit: {
    subject: 'AppraisalBuilderPlans',
    actions: 'edit',
  },
  AppraisalUIMaintenanceEdit: {
    subject: 'AppraisalUIMaintenance',
    actions: 'edit',
  },
  AppraisalUIMaintenanceView: {
    subject: 'AppraisalUIMaintenance',
    actions: 'view',
  },
  AppraisalCodefileMaintenanceEdit: {
    subject: 'AppraisalCodefileMaintenance',
    actions: 'edit',
  },
  AppraisalCodefileMaintenanceView: {
    subject: 'AppraisalCodefileMaintenance',
    actions: 'view',
  },
  AppraisalAbstractSudvidisionMaintenanceEdit: {
    subject: 'AppraisalAbstractSudvidisionMaintenance',
    actions: 'edit',
  },
  AppraisalAbstractSubdivisionMaintenanceView: {
    subject: 'AppraisalAbstractSudvidisionMaintenance',
    actions: 'view',
  },
  AppraisalMarketAreaMaintenanceEdit: {
    subject: 'AppraisalMarketAreaMaintenance',
    actions: 'edit',
  },
  AppraisalMarketAreaMaintenanceView: {
    subject: 'AppraisalMarketAreaMaintenance',
    actions: 'view',
  },
  AppraisalWalkthruSettingsEdit: {
    subject: 'AppraisalWalkthruSettings',
    actions: 'edit',
  },
  AppraisalWalkthruSettingsView: {
    subject: 'AppraisalWalkthruSettings',
    actions: 'view',
  },
  AppraisalPricingTableEdit: {
    subject: 'AppraisalPricingTable',
    actions: 'edit',
  },
  AppraisalPricingTableView: {
    subject: 'AppraisalPricingTable',
    actions: 'view',
  },
  AppraisalExecuteMassRecalculation: {
    subject: 'AppraisalMassRecalculation',
    actions: 'execute',
  },
  AppraisalAppraiserSettingsEdit: {
    subject: 'AppraisalAppraiserSettings',
    actions: 'edit',
  },
  AppraisalAppraiserSettingsView: {
    subject: 'AppraisalAppraiserSettings',
    actions: 'view',
  },
  AppraisalCacheRebuild: {
    subject: 'AppraisalCacheRebuild',
    actions: 'execute',
  },
  AppraisalLandModelEdit: {
    subject: 'AppraisalLandModel',
    actions: 'edit',
  },
  AppraisalLandModelView: {
    subject: 'AppraisalLandModel',
    actions: 'view',
  },
  AppraisalImprovementModelEdit: {
    subject: 'AppraisalImprovementModel',
    actions: 'edit',
  },
  AppraisalImprovementModelView: {
    subject: 'AppraisalImprovementModel',
    actions: 'view',
  },
  AppraisalBppModelEdit: {
    subject: 'AppraisalBppModel',
    actions: 'edit',
  },
  AppraisalBppModelView: {
    subject: 'AppraisalBppModel',
    actions: 'view',
  },
  AppraisalValueLimitationView: {
    subject: 'AppraisalValueLimitation',
    actions: 'view',
  },
  AppraisalValueLimitationEdit: {
    subject: 'AppraisalValueLimitation',
    actions: 'edit',
  },
  AppraisalPropertyLinksEdit: {
    subject: 'AppraisalPropertyLinks',
    actions: 'edit',
  },
  AppraisalPropertyLinksView: {
    subject: 'AppraisalPropertyLinks',
    actions: 'view',
  },
  AppraisalPropertyTagsEdit: {
    subject: 'AppraisalPropertyTags',
    actions: 'edit',
  },
  AppraisalPropertyTagsView: {
    subject: 'AppraisalPropertyTags',
    actions: 'view',
  },
  AppraisalPropertyLastAppraisalEdit: {
    subject: 'AppraisalPropertyLastAppraisal',
    actions: 'edit',
  },
  AppraisalPropertyLastAppraisalView: {
    subject: 'AppraisalPropertyLastAppraisal',
    actions: 'view',
  },
  AppraisalZillowView: {
    subject: 'AppraisalZillow',
    actions: 'view',
  },
  AppraisalMapView: {
    subject: 'AppraisalMap',
    actions: 'view',
  },
  AppraisalValuationBppView: {
    subject: 'AppraisalValuationBpp',
    actions: 'view',
  },
  AppraisalValuationBppEdit: {
    subject: 'AppraisalValuationBpp',
    actions: 'edit',
  },
  AppraisalInspectionView: {
    subject: 'AppraisalInspection',
    actions: 'view',
  },
  AppraisalInspectionEdit: {
    subject: 'AppraisalInspection',
    actions: 'edit',
  },
  AppraisalAppraiserView: {
    subject: 'AppraisalAppraiser',
    actions: 'view',
  },
  AppraisalAppraiserEdit: {
    subject: 'AppraisalAppraiser',
    actions: 'edit',
  },
  AppraisalPropertyExemptionCommentsEdit: {
    subject: 'AppraisalPropertyExemptionComments',
    actions: 'edit',
  },
  AppraisalPropertyExemptionCommentsView: {
    subject: 'AppraisalPropertyExemptionComments',
    actions: 'view',
  },
  AppraisalExecuteExemptionWalkthru: {
    subject: 'AppraisalExemptionWalkthru',
    actions: 'execute',
  },
  AppraisalExecuteDeleteProperty: {
    subject: 'AppraisalDeleteProperty',
    actions: 'execute',
  },
  AppraisalRenditionsView: {
    subject: 'AppraisalRenditions',
    actions: 'view',
  },
  AppraisalRenditionsEdit: {
    subject: 'AppraisalRenditions',
    actions: 'edit',
  },
  AppraisalPropertyApplicationEdit: {
    subject: 'AppraisalPropertyApplication',
    actions: 'edit',
  },
  AppraisalPropertyApplicationView: {
    subject: 'AppraisalPropertyApplication',
    actions: 'view',
  },
  AppraisalBuildingPermitsEdit: {
    subject: 'AppraisalBuildingPermits',
    actions: 'edit',
  },
  AppraisalBuildingPermitsView: {
    subject: 'AppraisalBuildingPermits',
    actions: 'view',
  },
  AppraisalMarketAreaReopen: {
    subject: 'AppraisalMarketAreaReopen',
    actions: 'execute',
  },
  AppraisalViewEfilePin: {
    subject: 'AppraisalEfilePin',
    actions: 'view',
  },
  AgentViewEfilePin: {
    subject: 'AgentEfilePin',
    actions: 'view',
  },
  AppraisalRollCorrectionCreateGroup: {
    subject: 'AppraisalRollCorrectionCreateGroup',
    actions: 'execute',
  },
  QueueCodefileMaintenanceEdit: {
    subject: 'QueueCodefileMaintenance',
    actions: 'edit',
  },
  QueueAdministration: {
    subject: 'QueueAdministration',
    actions: 'execute',
  },
  QueueBatchImport: {
    subject: 'QueueBatchImport',
    actions: 'execute',
  },
  QueueMoveItemsMass: {
    subject: 'QueueMoveItemsMass',
    actions: 'execute',
  },
  QueueReopenFinalizedWorkItem: {
    subject: 'QueueReopenFinalizedWorkItem',
    actions: 'execute',
  },
  QueueUpdateStatusMass: {
    subject: 'QueueUpdateStatusMass',
    actions: 'execute',
  },
  AppraisalMassCreateCompGrids: {
    subject: 'AppraisalMassCreateCompGrids',
    actions: 'execute',
  },
  AppraisalMassUpdateExecute: {
    subject: 'AppraisalMassUpdateExecute',
    actions: 'execute',
  },
  AppraisalMassInactivate: {
    subject: 'AppraisalMassInactivate',
    actions: 'execute',
  },
  AppraisalBuildingPermitImport: {
    subject: 'AppraisalBuildingPermitImport',
    actions: 'execute',
  },
};

export const widgetType = {
  legaldescription: 'AppraisalLegalDescription',
  mineralLegalDescription: 'AppraisalLegalDescription',
  identification: 'PropertyIdentification',
  characteristics: 'AppraisalPropertyCharacteristics',
  cardOwner: 'AppraisalOwner',
  cardSitus: 'AppraisalSitusAddress',
  cardTaxingUnit: 'AppraisalTaxingUnits',
  cardExemptions: 'AppraisalExemptions',
  cardLandBuilding: 'AppraisalValuation',
  cardValueSummary: 'AppraisalValuation',
  cardLegalDescription: 'AppraisalLegalDescription',
  situs: 'AppraisalSitusAddress',
  taxingunits: 'AppraisalTaxingUnits',
  valuations: 'AppraisalValuation',
  owners: 'AppraisalOwner',
  deeds: 'AppraisalDeeds',
  exemptions: 'AppraisalExemptions',
  events: 'AppraisalPropertyEvents',
  sales: 'AppraisalSales',
  'valuations-bpp': 'AppraisalBPPPersonalDetail',
  valuelimitations: 'AppraisalValueLimitation',
  lastAppraisal: 'AppraisalPropertyLastAppraisal',
  propertyTags: 'AppraisalPropertyTags',
  propertyLinks: 'AppraisalPropertyLinks',
  agents: 'AppraisalAgent',
  comments: 'AppraisalPropertyComments',
  smartgroups: 'AppraisalSmartGroups',
  zillow: 'AppraisalZillow',
  cardAgents: 'AppraisalAgent',
  googlemap: 'AppraisalMap',
  bingmap: 'AppraisalMap',
  inspections: 'AppraisalInspection',
  appraisers: 'AppraisalAppraiser',
  exemptionComments: 'AppraisalPropertyExemptionComments',
  'renditions-bpp': 'AppraisalRenditions',
  lateRenditionPenalty: 'AppraisalRenditions',
  renditionExtension: 'AppraisalRenditions',
  applications: 'AppraisalPropertyApplication',
  buildingpermits: 'AppraisalBuildingPermits',
};
